import { Title } from "melco-ui";
import { StatisticsBarChart } from "./StatisticsBarChart";
import { StatisticsConfig } from "../../../../hooks/reporting/statistics/useStatistics";
import { ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

type ThreadBreaksProps = {
  dataConfig?: StatisticsConfig;
  data?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem;
  isLoading?: boolean;
};

export const ThreadBreaks: React.FC<ThreadBreaksProps> = ({
  data,
  dataConfig,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Title level={5}>{t("reporting.statistics.charts.thread_breaks")}</Title>
      <StatisticsBarChart
        field="thread_breaks"
        dataConfig={{ ...dataConfig, sortBy: "thread_breaks" }}
        data={data}
        isLoading={isLoading}
      />
    </>
  );
};
